import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20inviting%20modern%20office%20interior%20with%20natural%20sunlight%20streaming%20through%20large%20windows%2C%20cream%20walls%20with%20abstract%20textile%20art%2C%20minimal%20desk%20with%20laptop%2C%20indoor%20plants%20including%20fiddle%20leaf%20fig%2C%20calm%20productive%20atmosphere%2C%20soft%20earthy%20color%20palette%20with%20terracotta%20accents%2C%20editorial%20interior%20photography&width=1400&height=500&seq=cta-bg-v2&orientation=landscape"
              alt="Shop with Vigorbuy Spreadsheet"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-900/70 to-primary-800/50"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 py-12 md:py-16 px-6 md:px-12 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3">
              Ready to Start Shopping Smarter?
            </h2>
            <p className="text-sm md:text-base text-background-100/90 max-w-lg mx-auto mb-8">
              Join thousands of smart shoppers using Vigorbuy Spreadsheet to discover products faster and make informed purchasing decisions every day.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3 text-sm font-semibold text-primary-700 bg-background-50 hover:bg-background-100 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                Vigorbuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
              <Link
                to="/guide/vigorbuy-spreadsheet-complete-guide"
                className="text-sm font-medium text-background-100 hover:text-background-50 underline underline-offset-4 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Our Guide →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}